import './scss/index.scss';
import { dcFactory } from '@deleteagency/dc';
import shareEventObserver from './js/share-event-observer';
import ShareToolboxComponent from './js/share-toolbox.component';
import ShareCollapsedComponent from './js/share-collapsed.component';

dcFactory.register(ShareToolboxComponent);
dcFactory.register(ShareCollapsedComponent);
shareEventObserver.start();
